import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { initFlowbite } from "flowbite";
import Checkout from "../PaymentGateway/Checkout";
import axios from "axios";
import { baseURL, cdnPath } from "@/utility/api";
import SessionConfirmation from "./SessionConfirmation";
import { MainContext } from "@/context/MainContext";
import { parse } from "postcss";

export default function ProductPayment() {
  const queryString = window.location.search;
  const searchParams = new URLSearchParams(queryString);
  const { user, isLoading } = useContext(MainContext);
  const type = searchParams.get("type");
  const date = searchParams.get("date");
  const isReschedule = searchParams.get("isReschedule");
  const rescheduleFor = searchParams.get("rescheduleFor");
  const isFriend = searchParams.get("isFriend");
  const price = searchParams.get("price");
  const isRebook = searchParams.get("isRebook");
  const { id } = useParams();
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);
  const [whatsapp, setWhatsapp] = useState(false);
  const [info, setInfo] = useState({
    id: id,
    name: "",
    email: "",
    phone_number: "",
    type: type,
    booked_date: date,
    is_reschedule: isReschedule,
    reschedule_for: rescheduleFor,
    friend_email: "",
    isFriend: isFriend,
    isRebook: isRebook,
    isWhatsapp: false,
  });

  useEffect(() => {
    initFlowbite();
    async function fetchData() {
      try {
        const response = await axios.post(`${baseURL}/${type}/get-details`, {
          id: id,
          isReschedule,
          isFriend,
          isRebook,
        });
        setDetails(response.data);
      } catch (error) {
        console.error("Error fetching details:", error);
      } finally {
      }
    }

    if (isReschedule !== undefined) {
      fetchData();
    }

    if (isReschedule === "true" || isRebook == "true") {
      setInfo({
        ...info,
        name: user?.username,
        email: user?.email,
        phone_number: user?.phone_number,
      });
    }
  }, [type, id, isReschedule, isLoading, isFriend]);

  // In your component
  useEffect(() => {
    // Re-initialize tooltips whenever the component updates
    initTooltips();
  }, [info.isWhatsapp]); // Re-run when WhatsApp condition changes

  console.log("det", details);

  return (
    <>
      <div className="w-full max-w-md mx-auto bg-secondary-300 text-gray-100 rounded-lg shadow-md overflow-hidden pb-20 md:mt-20 mt-[3.2rem] ">
        <div className="flex items-center space-x-4 p-4 border-b border-gray-700 ">
          <button
            className="text-gray-400 hover:text-gray-200"
            onClick={() => navigate(-1)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 rounded-full bg-gray-600">
              <img
                src={`${cdnPath}/${details?.author_image}`}
                alt=""
                className="w-full h-full object-cover rounded-full"
              />
            </div>
            <span className="font-semibold">{details?.author}</span>
          </div>
        </div>
        <div className="p-4">
          <div className="px-4">
            <h1 className="text-2xl font-bold mb-2">{details?.title}</h1>
            <p className="text-sm text-gray-400 mb-4">{details?.type}</p>
            <div className="my-3">
              {type === "session" && <SessionConfirmation inputdate={date} />}
            </div>
          </div>
          <div className="p-4">
            <form>
              <div className="space-y-4">
                <div>
                  <label
                    htmlFor="name"
                    className="block text-sm font-medium text-gray-300"
                  >
                    Name
                  </label>

                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Enter your name"
                    className={`mt-1 block w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-md shadow-sm text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${
                      isReschedule === "true" || isRebook == "true"
                        ? "opacity-100 cursor-not-allowed"
                        : ""
                    }`}
                    value={
                      isReschedule === "true" || isRebook == "true"
                        ? user?.username
                        : info.name
                    } // Set the default value
                    onChange={(e) => setInfo({ ...info, name: e.target.value })}
                    disabled={isReschedule === "true" || isRebook == "true"} // Prevent editing if rescheduling
                  />
                </div>

                {/* Whatsapp checkbox feature from here */}
                <div>
                  <input
                    type="checkbox"
                    id="whatsappCheckbox"
                    checked={info.isWhatsapp}
                    onChange={(e) => {
                      // const checked = e.target.checked;
                      // setWhatsapp(checked);
                      setInfo({ ...info, isWhatsapp: e.target.checked });
                    }}
                    className="w-4 h-4 accent-blue-500 rounded cursor-pointer"
                  />
                  <label
                    htmlFor="whatsappCheckbox"
                    className=" text-sm ml-2 font-medium text-white-300 cursor-pointer"
                  >
                    Jobs & internships on WhatsApp at just ₹
                  {details?.whatsappprice || 9}
                  </label>

                  {/* <input 
            type="text" 
            id="name" 
            name="name" 
            placeholder="Enter your name" 
            className={`mt-1 block w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-md shadow-sm text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${
              isReschedule === 'true' || isRebook == 'true' ? 'opacity-100 cursor-not-allowed' : ''
            }`} 
            value={isReschedule === 'true' || isRebook == 'true' ?  user?.username : info.name} // Set the default value
            onChange={(e) => setInfo({ ...info, name: e.target.value })}
            disabled={isReschedule === 'true' || isRebook == 'true'} // Prevent editing if rescheduling
            /> */}
                </div>

                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-300"
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    className={`mt-1 block w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-md shadow-sm text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${
                      isReschedule === "true" || isRebook == "true"
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                    }`}
                    value={
                      isReschedule === "true" || isRebook == "true"
                        ? user?.email
                        : info.email
                    } // Set the default value
                    onChange={(e) =>
                      setInfo({ ...info, email: e.target.value })
                    }
                    disabled={isReschedule === "true" || isRebook == "true"} // Prevent editing if rescheduling
                  />
                </div>

                {isFriend == "true" && (
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-300"
                    >
                      Friend's Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Enter your friend's email"
                      className={`mt-1 block w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-md shadow-sm text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${
                        isReschedule === "true" || isRebook == "true"
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                      }`}
                      value={
                        isReschedule === "true" || isRebook == "true"
                          ? user?.email
                          : info.friend_email
                      } // Set the default value
                      onChange={(e) =>
                        setInfo({ ...info, friend_email: e.target.value })
                      }
                      disabled={isReschedule === "true" || isRebook == "true"} // Prevent editing if rescheduling
                    />
                  </div>
                )}

                <div>
                  <label
                    htmlFor="phone"
                    className="block text-sm font-medium text-gray-300"
                  >
                    Phone number
                  </label>
                  <div className="flex mt-1">
                    <select className="block px-3 py-2 bg-gray-700 border border-gray-600 rounded-l-md shadow-sm text-gray-100 focus:outline-none focus:ring-blue-500 focus:border-blue-500">
                      <option value="+91">🇮🇳 +91</option>
                    </select>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      placeholder="Enter your phone number"
                      className={`flex-1 block w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-r-md shadow-sm text-gray-100 placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${
                        isReschedule === "true" || isRebook == "true"
                          ? "opacity-50 cursor-not-allowed"
                          : ""
                      }`}
                      value={
                        isReschedule === "true" || isRebook == "true"
                          ? parseInt(user?.phone_number, 10)
                          : info.phone_number
                      } // Set the default value
                      onChange={(e) =>
                        setInfo({ ...info, phone_number: e.target.value })
                      }
                      onInput={(e) => {
                        if (!isReschedule) {
                          // Remove non-numeric characters
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            ""
                          );
                        }
                      }}
                      disabled={isReschedule === "true"} // Prevent editing if rescheduling
                      maxLength="10" // Optional: Limit phone number to 10 digits
                    />
                  </div>
                </div>

                {/* <div className="flex items-center space-x-2">
              <input 
                type="checkbox" 
                id="booking" 
                name="booking" 
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 bg-gray-700 border-gray-600 rounded" 
              />
              <label htmlFor="booking" className="text-sm text-gray-300">Receive booking details on phone</label>
            </div> */}

                <div className="mt-6 bg-gray-700 rounded-md p-4">
                  <h2 className="text-lg font-semibold mb-4 flex">
                    Order Summary{" "}
                    {isReschedule === "true" && (
                      <>
                        <div
                          id="tooltip-animation"
                          role="tooltip"
                          class="absolute z-10 invisible  px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700 flex"
                        >
                          Rescheduling comes with a small fee to <br></br>help
                          us manage our time too.
                          <br></br> Thanks for understanding!
                          <br></br>
                          delivering a seamless experience
                          <div class="tooltip-arrow" data-popper-arrow></div>
                        </div>
                        <span className="flex items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            data-tooltip-target="tooltip-animation"
                            className="h-4 w-4 ml-1 text-gray-400"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                        </span>
                      </>
                    )}
                  </h2>

                  <div className="space-y-2">
                    <div className="flex justify-between flex-col">
                      <div className="flex justify-between">
                        <span>1 x {details?.title}</span>
                        <span>
                          ₹{price ? price : details?.discounted_price}
                        </span>
                      </div>
                      {isFriend === "true" && (
                        <div className="flex justify-between">
                          <span className="flex">
                            1 x Bring Your Friend
                            <>
                              <div
                                id="tooltip-friend"
                                role="tooltip"
                                class="absolute z-10 invisible  px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700 flex"
                              >
                                Rescheduling comes with a small fee to <br></br>
                                help us manage our time too.
                                <br></br> Thanks for understanding!
                                <br></br>
                                delivering a seamless experience
                                <div
                                  class="tooltip-arrow"
                                  data-popper-arrow
                                ></div>
                              </div>
                              <span className="flex items-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  data-tooltip-target="tooltip-friend"
                                  className="h-4 w-4 ml-1 text-gray-400"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                  />
                                </svg>
                              </span>
                            </>
                          </span>
                          <span>₹{details?.bring_friend_price || 0}</span>
                        </div>
                      )}
                      {info.isWhatsapp && (
                        <div className="flex justify-between">
                          <span className="flex">
                            1 x Whatsapp Group
                            <>
                              <div
                                id="tooltip-whatsapp"
                                role="tooltip"
                                class="absolute z-10 invisible  px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700 flex"
                              >
                                You will have exclusive access to latest{" "}
                                <br></br>
                                Internship/Job Openings.
                                <br></br> On our Whatsapp Group!
                                <br></br>
                                Whatsapp group link will be sent to your email.
                                <div
                                  class="tooltip-arrow"
                                  data-popper-arrow
                                ></div>
                              </div>
                              <span className="flex items-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  data-tooltip-target="tooltip-whatsapp"
                                  className="h-4 w-4 ml-1 text-gray-400"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                  />
                                </svg>
                              </span>
                            </>
                          </span>
                          <span>₹{details?.whatsapp_group_price || 0}</span>
                        </div>
                      )}
                    </div>
                    <div className="flex justify-between">
                      <div
                        id="tooltip-animation"
                        role="tooltip"
                        class="absolute z-10 invisible  px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700 flex"
                      >
                        This fee helps us operate and
                        <br></br> improve our platform,
                        <br></br>
                        delivering a seamless experience
                        <div class="tooltip-arrow" data-popper-arrow></div>
                      </div>
                      {/* <span className="flex items-center">
                    Platform fee
                    <svg xmlns="http://www.w3.org/2000/svg" data-tooltip-target="tooltip-animation" className="h-4 w-4 ml-1 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </span>
                  <span>₹5</span> */}
                    </div>
                    <div className="flex justify-between font-semibold pt-2 border-t border-gray-600">
                      <span>Total</span>
                      <span>
                        {" "}
                        ₹
                        {parseInt(price || details?.discounted_price || 0) +
                          parseInt(details?.bring_friend_price || 0) +
                          (info.isWhatsapp
                            ? parseInt(details?.whatsapp_group_price || 0)
                            : 0)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <div className="mt-4 text-sm text-gray-400 flex flex-col justify-between items-center">
              <span className="flex items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  />
                </svg>
                Payments are 100% secure & encrypted
              </span>

              <span>
                <a
                  href="/terms-of-service"
                  className="text-blue-400 hover:underline"
                >
                  Terms
                </a>{" "}
                |{" "}
                <a
                  href="/privacy-policy"
                  className="text-blue-400 hover:underline"
                >
                  Privacy
                </a>
              </span>
            </div>
            <div className="mt-4 text-center text-sm text-gray-400">
              Powered by off-campus.in
            </div>
          </div>
        </div>
      </div>
      <div className="fixed bottom-0 left-0 right-0  p-4 border-t border-gray-700 bg-secondary-300 max-w-md mx-auto">
        <div className="w-full   flex justify-between items-center">
          <button
            type="button"
            className="px-4 py-2 bg-gray-700 text-gray-200 rounded-md flex items-center hover:bg-gray-600 transition-colors"
          >
            ₹
            {parseInt(price || details?.discounted_price || 0) +
              parseInt(details?.bring_friend_price || 0) +
              (info.isWhatsapp
                ? parseInt(details?.whatsapp_group_price || 0)
                : 0)}
            +
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 ml-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>

          <Checkout info={info} title={"Confirm and Pay"} />
        </div>
      </div>
    </>
  );
}
